import React from "react"
import ContentBrowser from "aldoo-ra/CMS/browsers/content-browser"
import { previewImage } from "aldoo-ra/CMS/preview"
import Tooltip from "aldoo-ra/Tooltip"

export default function BlogCategoryBrowser() {
  return (
    <ContentBrowser
      contentType="BlogCategory"
      contentTitle="Blog Categories"
      addButtonText="Add"
      allowTypeSelection={false}
      allowTypeBrowsing={false}
      showPreview={true}
      searchFields="content.title content.name"
      additionalColumns={[
        {
          id: "title",
          title: "Title",
          headerClassName: "w-[250px]",
          render: (value, item) => {
            const preview = previewImage(item)

            return (
              <div className="flex flex-row items-center">
                {preview && (
                  <Tooltip
                    content={
                      <div className="text-center">
                        <span className="font-bold text-admin_text">
                          {item?.content.label}
                        </span>
                        <img
                          src={preview}
                          className="w-[400px] h-[400px] object-contain mr-2 rounded-[10px]"
                        />
                      </div>
                    }
                    position="right"
                  >
                    <img
                      src={preview}
                      className="w-10 h-10 mr-2 rounded-[10px]"
                    />
                  </Tooltip>
                )}
                <span 
                  className="ml-2 text-admin_text cursor-pointer hover:text-admin_primary transition-colors"
                  onClick={() => {
                    if (item && item._id && item.onEdit) {
                      item.onEdit(item)
                    }
                  }}
                >
                  {item?.content.title}
                </span>
              </div>
            )
          },
        },
      ]}
    />
  )
}
